import { AssertionError } from '../errors/assert.js';

function assert(condition, msg) {
    if (!condition) {
        throw new AssertionError(msg);
    }
}

export { assert };
//# sourceMappingURL=assert.js.map
